<template>
  <div class='navbar'
       :style="{background:$store.state.isChangeNavBarStyle? '#212121' : '#fff',boxShadow: isShowDrawer ? '' :'0 10px 20px 0 RGBA(0, 0, 0, 0.1)'}">
    <loading :active.sync="loading"
             :can-cancel="true"
             :is-full-page="true">
    </loading>
    <div class="nav_container">
      <div class="logo">
        <img :src="$store.state.isChangeNavBarStyle ? 'static/newVersionImgs/logo_short.svg' : 'static/newVersionImgs/logo.svg'"
             :class="[$store.state.isChangeNavBarStyle? 'logo_short_img' : 'logo_img']"
             @click="logoOpt">
      </div>
      <div class="category_container"
           v-show="$store.state.isChangeNavBarStyle">
        <el-popover
          popper-class="popover_label"
          placement="bottom"
          width="300"
          :offset="80"
          :visible-arrow="false"
          trigger="hover">
          <div slot="reference"
               style="margin-left:30px"
               :class="{video_type_btn:true,video_type_btn_active:searchCategory === 'tvseries'}">
            <img src="/static/newVersionImgs/nav_category_tvseries.svg"
                 class="tv_series">
            <span class="category_name">{{ $t('label.tvseries') }}</span>
          </div>
          <div>
            <div style="color: #666666;font-size: 16px;font-weight: bold;margin-left:25px;">
              {{$t('label.listTitle')}}
            </div>
            <div style="display: flex;align-item:center;justfy-content:space-between;flex-wrap:wrap;">
              <div style="color: #666666;font-size: 14px;margin-top:5px;width:50%;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                   @click="navbarSelectNewVideoCategory('tvseries','all',0)"
                   class="label_title">
                <div style="width:20px;">
                  <img src="/static/newVersionImgs/language_check.svg"
                       v-show="searchCategory === 'tvseries' && searchSubCategory === 'all'"
                       style="width:13px">
                </div>
                <span :style="{fontWeight: searchCategory === 'tvseries' && searchSubCategory === 'all' ? 'bold' : '',color:searchCategory === 'tvseries' && searchSubCategory === 'all' ? '#000' : ''}">{{$t('label.all')}}</span>
              </div>
              <div style="color: #666666;font-size: 14px;margin-top:5px;width:50%;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                   v-for="(item,idx) in $t('shareSubCategoryTVseries')"
                   :key="idx"
                   @click="navbarSelectNewVideoCategory('tvseries',item.value,0)"
                   class="label_title">
                <div style="width:20px;">
                  <img src="/static/newVersionImgs/language_check.svg"
                       v-show="searchCategory === 'tvseries' && searchSubCategory === item.value"
                       style="width:13px">
                </div>
                <span :style="{fontWeight: searchCategory === 'tvseries' && searchSubCategory === item.value ? 'bold' : '',color:searchCategory === 'tvseries' && searchSubCategory === item.value ? '#000' : ''}">{{item.label}}</span>
              </div>
            </div>
          </div>
        </el-popover>
        <el-popover
          placement="bottom"
          popper-class="popover_label"
          width="300"
          :offset="80"
          :visible-arrow="false"
          trigger="hover">
          <div slot="reference"
               :class="{video_type_btn:true,video_type_btn_active:searchCategory === 'movies'}">
            <img src="/static/newVersionImgs/nav_category_movie.svg"
                 class="tv_series">
            <span class="category_name">{{ $t('label.movie') }}</span>
          </div>
          <div>
            <div style="color: #666666;font-size: 16px;font-weight: bold;margin-left:25px;">
              {{$t('label.listTitle')}}
            </div>
            <div style="display: flex;align-item:center;justfy-content:space-between;flex-wrap:wrap;">
              <div style="color: #666666;font-size: 14px;margin-top:5px;width:50%;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                   @click="navbarSelectNewVideoCategory('movies','all',0)"
                   class="label_title">
                <div style="width:20px;">
                  <img src="/static/newVersionImgs/language_check.svg"
                       v-show="searchCategory === 'movies' && searchSubCategory === 'all'"
                       style="width:13px">
                </div>
                <span :style="{fontWeight: searchCategory === 'movies' && searchSubCategory === 'all' ? 'bold' : '',color:searchCategory === 'movies' && searchSubCategory === 'all' ? '#000' : ''}">{{$t('label.all')}}</span>
              </div>
              <div style="color: #666666;font-size: 14px;margin-top:5px;width:50%;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                   v-for="(item,idx) in $t('shareSubCategoryMovie')"
                   :key="idx"
                   @click="navbarSelectNewVideoCategory('movies',item.value,0)"
                   class="label_title">
                <div style="width:20px;">
                  <img src="/static/newVersionImgs/language_check.svg"
                       v-show="searchCategory === 'movies' && searchSubCategory === item.value"
                       style="width:13px">
                </div>
                <span :style="{fontWeight: searchCategory === 'movies' && searchSubCategory === item.value ? 'bold' : '',color:searchCategory === 'movies' && searchSubCategory === item.value ? '#000' : ''}">{{item.label}}</span>
              </div>
            </div>
          </div>
        </el-popover>
        <el-popover
          placement="bottom"
          popper-class="popover_label"
          width="300"
          :offset="80"
          :visible-arrow="false"
          trigger="hover">
          <div slot="reference"
               :class="{video_type_btn:true,video_type_btn_active:searchCategory === 'entertainment'}">
            <img src="/static/newVersionImgs/nav_category_entertainment.svg"
                 class="tv_series">
            <span class="category_name">{{ $t('label.ent') }}</span>
          </div>
          <div>
            <div style="color: #666666;font-size: 16px;font-weight: bold;margin-left:25px;">
              {{$t('label.listTitle')}}
            </div>
            <div style="display: flex;align-item:center;justfy-content:space-between;flex-wrap:wrap;">
              <div style="color: #666666;font-size: 14px;margin-top:5px;width:50%;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                   @click="navbarSelectNewVideoCategory('entertainment','all',0)"
                   class="label_title">
                <div style="width:20px;">
                  <img src="/static/newVersionImgs/language_check.svg"
                       v-show="searchCategory === 'entertainment' && searchSubCategory === 'all'"
                       style="width:13px">
                </div>
                <span :style="{fontWeight: searchCategory === 'entertainment' && searchSubCategory === 'all' ? 'bold' : '',color:searchCategory === 'entertainment' && searchSubCategory === 'all' ? '#000' : ''}">{{$t('label.all')}}</span>
              </div>
              <div style="color: #666666;font-size: 14px;margin-top:5px;width:50%;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                   v-for="(item,idx) in $t('shareSubCategoryEntertainment')"
                   :key="idx"
                   @click="navbarSelectNewVideoCategory('entertainment',item.value,0)"
                   class="label_title">
                <div style="width:20px;">
                  <img src="/static/newVersionImgs/language_check.svg"
                       v-show="searchCategory === 'entertainment' && searchSubCategory === item.value"
                       style="width:13px">
                </div>
                <span :style="{fontWeight: searchCategory === 'entertainment' && searchSubCategory === item.value ? 'bold' : '',color:searchCategory === 'entertainment' && searchSubCategory === item.value ? '#000' : ''}">{{item.label}}</span>
              </div>
            </div>
          </div>
        </el-popover>
        <el-popover
          placement="bottom"
          popper-class="popover_label"
          width="300"
          :offset="80"
          :visible-arrow="false"
          trigger="hover">
          <div slot="reference"
               :class="{video_type_btn:true,video_type_btn_active:searchCategory === 'other'}">
            <img src="/static/newVersionImgs/nav_category_other.svg"
                 class="tv_series">
            <span class="category_name">{{ $t('text.other') }}</span>
          </div>
          <div>
            <div style="color: #666666;font-size: 16px;font-weight: bold;margin-left:25px;">
              {{$t('label.listTitle')}}
            </div>
            <div style="display: flex;align-item:center;justfy-content:space-between;flex-wrap:wrap;">
              <div style="color: #666666;font-size: 14px;margin-top:5px;width:50%;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                   @click="selectNewVideoCategory('other','all',3)"
                   class="label_title">
                <div style="width:20px;">
                  <img src="static/newVersionImgs/language_check.svg"
                       v-show="searchCategory === 'other' && searchSubCategory === 'all'"
                       style="width:13px">
                </div>
                <span :style="{fontWeight: searchCategory === 'other' && searchSubCategory === 'all' ? 'bold' : '',color:searchCategory === 'other' && searchSubCategory === 'all' ? '#000' : ''}">{{$t('label.all')}}</span>
              </div>
              <div style="color: #666666;font-size: 14px;margin-top:5px;width:50%;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                   v-for="(item,idx) in $t('shareSubCategoryOther')"
                   :key="idx"
                   @click="navbarSelectNewVideoCategory('other',item.value,0)"
                   class="label_title">
                <div style="width:20px;">
                  <img src="/static/newVersionImgs/language_check.svg"
                       v-show="searchCategory === 'other' && searchSubCategory === item.value"
                       style="width:13px">
                </div>
                <span :style="{fontWeight: searchCategory === 'other' && searchSubCategory === item.value ? 'bold' : '',color:searchCategory === 'other' && searchSubCategory === item.value ? '#000' : ''}">{{item.label}}</span>
              </div>
            </div>
          </div>
        </el-popover>
      </div>
      <div :class="[$store.state.isChangeNavBarStyle ? 'ipt_change' : 'ipt']">
        <el-input
          :placeholder="$t('navText.placeholder')"
          class="search_ipt"
          maxlength="20"
          v-model="searchKeyWords"
          @change="searchVideos">
          <div class="search_btn"
               slot="append"
               @click="searchVideos">
            {{$t('navText.search')}}
          </div>
        </el-input>
      </div>
      <div class="opt_btn">
        <div class="opt_share opt_common"
             :style="{'--bgc-color':$store.state.isChangeNavBarStyle?'#171717':'#f2f2f2',justifyContent:$store.state.isChangeNavBarStyle?'center':'space-between'}"
             @click="openShareModal">
          <img src="/static/newVersionImgs/opt_share.svg">
          <span class="opt_text"
                v-show="!$store.state.isChangeNavBarStyle">{{$t('navText.share')}}</span>
        </div>
        <div class="opt_sign opt_common"
             :style="{'--bgc-color':$store.state.isChangeNavBarStyle?'#171717':'#f2f2f2',justifyContent:$store.state.isChangeNavBarStyle?'center':'space-between'}"
             @click="getDailyReward">
          <img src="/static/newVersionImgs/opt_sign.svg">
          <span class="opt_text"
                v-show="!$store.state.isChangeNavBarStyle">{{$t('navText.sign')}}</span>
        </div>
        <div class="opt_mine opt_common"
             :style="{'--bgc-color':$store.state.isChangeNavBarStyle?'#171717':'#f2f2f2',justifyContent:$store.state.isChangeNavBarStyle?'center':'space-between'}"
             @mouseover="setShowPanel(true,'menu')"
             @mouseleave="setShowPanel(false,'menu')">
          <img :src="userInfo? 'static/newVersionImgs/avatar.png' : 'static/newVersionImgs/opt_mine.svg'">
          <span class="opt_text"
                v-show="!$store.state.isChangeNavBarStyle">{{$t('navText.mine')}}</span>
        </div>
        <div class="opt_language opt_common"
             :style="{'--bgc-color':$store.state.isChangeNavBarStyle?'#171717':'#f2f2f2'}">
          <el-select placeholder=" "
                     v-model="optIdx"
                     popper-class="el_option"
                     @change="selectLanguage">
            <template slot="prefix">
              <img :src="options[optIdx].img">
            </template>
            <el-option
              v-for="item in options"
              :key="item.value"
              :value="item.value"
            >
              <img :src="item.img"
                   style="width:26px;height:28px">
              <span style="margin-left:10px;color:#000">{{item.label}}</span>
              <img src="/static/newVersionImgs/language_check.svg"
                   style="margin-left:10px"
                   v-show='item.value === optIdx'>
            </el-option>
          </el-select>
        </div>
      </div>
      <div :class="{login_panel:true}"
           @mouseover="isShowLoginPanel = true"
           @mouseleave="isShowLoginPanel = false"
           v-show="!userInfo && isShowLoginPanel">
        <div class="login_panel_title">
          {{$t('navText.loginPanelTitle')}}
        </div>
        <div class="login_panel_features">
          <div class="features">
            <img src="/static/newVersionImgs/opt_login_sign.png"
                 class="features_sign">
            <span>{{$t('navText.loginPanelText1')}}</span>
          </div>
          <div class="features">
            <img src="/static/newVersionImgs/opt_login_share.svg"
                 class="features_share">
            <span>{{$t('navText.loginPanelText2')}}</span>
          </div>
          <div class="features">
            <img src="/static/newVersionImgs/opt_login_comment.svg"
                 class="features_comment">
            <span>{{$t('navText.loginPanelText3')}}</span>
          </div>
        </div>
        <div class="login_panel_btn"
             @click="login">
          {{$t('navText.loginPanelBtnText')}}
        </div>
      </div>
      <div v-show="userInfo && isShowSettingPanel"
           :class="{setting_panel:true,login_panel:true}"
           @mouseover="isShowSettingPanel = true"
           @mouseleave="isShowSettingPanel = false">
        <Profile></Profile>
      </div>
    </div>
    <div class="nav_container_header_mobile">
      <div class="mobile_sign"
           @click="jumpSign">
        <el-tooltip v-model="isShowTips"
                    manual
                    placement="bottom"
                    popper-class="category_tooltip"
                    v-if="!$store.state.isPcClient">
          <img src="/static/newVersionImgs/mobile_sign.svg" >
          <template slot="content">
            <div @click="closeTips">
              {{$t('navText.loginPanelText1')}}
              <span style="margin-left:5px">x</span>
            </div>
          </template>
        </el-tooltip>
      </div>
      <div class="mobile_search">
        <el-input
          :placeholder="$t('navText.placeholder')"
          class="search_ipt"
          maxlength="20"
          v-model="searchKeyWords"
          @change="searchVideos">
        </el-input>
      </div>
      <div class="mobile_category">
        <div class="mobile_category_btn"
             @click="isShowDrawer = !isShowDrawer">
          {{$t('navText.select')}}
        </div>
        <el-drawer
          size="69%"
          custom-class="category_drawer"
          :visible.sync="isShowDrawer"
          direction="ttb"
          :modal="false"
          :show-close="false"
          :append-to-body="true"
          :withHeader="false">
          <div class="mobile_filter_container">
            <div class="subcategory_mobile">
              <div class="filter_title">
                {{$t('label.listTitle')}}
              </div>
              <div class="filter_des">
                <div style="color: #666666;font-size: 14px;margin-top:15px;width:33%;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                     @click="navbarSelectNewVideoCategory(searchCategory,'all',0)"
                     class="label_title"
                     v-show="searchCategory!='video'">
                  <div style="width:20px;">
                    <img src="/static/newVersionImgs/language_check.svg"
                         v-show="searchSubCategory === 'all'"
                         style="width:13px">
                  </div>
                  <span :style="{fontWeight: searchSubCategory === 'all' ? 'bold' : '',color: searchSubCategory === 'all' ? '#000' : ''}">{{$t('label.all')}}</span>
                </div>
                <div style="color: #666666;font-size: 14px;margin-top:15px;width:33%;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                     v-for="item in mobileSubcategory"
                     :key="item.value"
                     @click="navbarSelectNewVideoCategory(searchCategory,item.value,0)"
                     class="label_title">
                  <div style="width:20px;">
                    <img src="/static/newVersionImgs/language_check.svg"
                         v-show="searchSubCategory === item.value"
                         style="width:13px">
                  </div>
                  <span :style="{fontWeight: searchSubCategory === item.value ? 'bold' : '',color:searchSubCategory === item.value ? '#000' : '',whiteSpace: 'nowrap',overflow: 'hidden',textOverflow: 'ellipsis'}">{{item.label}}</span>
                </div>
              </div>
            </div>
            <div class="subcategory_mobile">
              <div class="filter_title">
                {{$t('label.listLanguageTitle')}}
              </div>
              <div class="filter_des">
                <div style="width:50%;color: #666666;font-size: 14px;margin-top:15px;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                     @click="mobileSelectLanguageVideo('audio','all')"
                     class="label_title">
                  <div style="width:20px;">
                    <img src="/static/newVersionImgs/language_check.svg"
                         v-show=" searchLanguage === 'all'"
                         style="width:13px">
                  </div>
                  <span :style="{fontWeight:  searchLanguage === 'all' ? 'bold' : '',color:searchLanguage === 'all' ? '#000' : ''}">{{$t('label.all')}}</span>
                </div>
                <div style="width:50%;color: #666666;font-size: 14px;margin-top:15px;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                     v-for="item in $t('shareSound')"
                     :key="item.value"
                     @click="mobileSelectLanguageVideo('audio',item.value)"
                     class="label_title">
                  <div style="width:20px;">
                    <img src="/static/newVersionImgs/language_check.svg"
                         v-show=" searchLanguage === item.value"
                         style="width:13px">
                  </div>
                  <span :style="{fontWeight: searchLanguage === item.value ? 'bold' : '',color: searchLanguage === item.value ? '#000' : ''}">{{item.label}}</span>
                </div>
              </div>
            </div>
            <div class="subcategory_mobile">
              <div class="filter_title">
                {{$t('label.listSubtitle')}}
              </div>
              <div class="filter_des">
                <div style="width:50%;color: #666666;font-size: 14px;margin-top:15px;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                     @click="mobileSelectLanguageVideo('subtitle','all')"
                     class="label_title">
                  <div style="width:20px;">
                    <img src="/static/newVersionImgs/language_check.svg"
                         v-show=" searchSubtitleLanguage === 'all'"
                         style="width:13px">
                  </div>
                  <span :style="{fontWeight:  searchSubtitleLanguage === 'all' ? 'bold' : '',color:searchSubtitleLanguage === 'all' ? '#000' : ''}">{{$t('label.all')}}</span>
                </div>
                <div style="width:50%;color: #666666;font-size: 14px;margin-top:15px;cursor:pointer;display: flex;align-item:center;justfy-content:space-between;"
                     v-for="item in $t('shareLanguage')"
                     :key="item.value"
                     @click="mobileSelectLanguageVideo('subtitle',item.value)"
                     class="label_title">
                  <div style="width:20px;">
                    <img src="/static/newVersionImgs/language_check.svg"
                         v-show=" searchSubtitleLanguage === item.value"
                         style="width:13px">
                  </div>
                  <span :style="{fontWeight: searchSubtitleLanguage === item.value ? 'bold' : '',color: searchSubtitleLanguage === item.value ? '#000' : ''}">{{item.label}}</span>
                </div>
              </div>
            </div>
            <div class="filter_btn_mobile"
                 @click="isShowDrawer = !isShowDrawer">
              {{$t('text.cancel')}}
            </div>
          </div>
        </el-drawer>
      </div>
    </div>
    <div class="nav_container_category_mobile">
      <van-tabs v-model="searchCategory"
                color="#F59595"
                :ellipsis="false"
                line-width="20px"
                @click="mobileNavbarSelect">
        <van-tab :title="$t('label.tvseries')"
                 :title-style="titleStyle"
                 name="tvseries"></van-tab>
        <van-tab :title="$t('label.movie')"
                 :title-style="titleStyle"
                 name="movies" ></van-tab>
        <van-tab :title="$t('label.ent')"
                 :title-style="titleStyle"
                 name="entertainment" ></van-tab>
        <van-tab :title="$t('text.other')"
                 :title-style="titleStyle"
                 name="other" ></van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapGetters, mapActions } from 'vuex'
import { getVideo } from '@/utils/api'
import { parseYoutubeVideoID, parseBilibiliVideoID, parseTencentVideoId, parseSuboVideoId } from '@/utils/common'
import Profile from '@/components/Profile'
export default{
    props: {
        parentName: {
            default: '',
            type: String
        }
    },
    data() {
        return {
            searchKeyWords: '',
            options: [{
                value: 0,
                label: 'English',
                img: require('../../static/newVersionImgs/opt_language_en.svg')
            },
            {
                value: 1,
                label: '简体中文',
                img: require('../../static/newVersionImgs/opt_language_cn.svg')
            }],
            optIdx: 0,
            loading: false,
            isShowLoginPanel: false,
            isShowSettingPanel: false,
            isShowTips: true,
            isShowDrawer: false,
            titleStyle: {fontWeight: 'bold'},
            mobileSubcategory: []
        }
    },
    mounted() {
        this.optIdx = this.$i18n.locale === 'cn' ? 1 : 0
        if (window.localStorage.getItem('isShowNavBarTips') !== null) {
            this.isShowTips = JSON.parse(window.localStorage.getItem('isShowNavBarTips'))
        }
        this.setMobileSubcategory(this.searchCategory)
    },
    computed: {
        ...mapGetters(['videoList', 'videoListCN', 'userInfo', 'sharingVideoURL', 'currentVideo', 'activePoint', 'userBalance', 'givePetalVideo', 'searchCategory', 'searchSubCategory', 'searchLanguage', 'searchSubtitleLanguage'])
    },
    methods: {
        ...mapActions(['clearVideos', 'selectVideo', 'setSharingVideoURL', 'setGivePetalVideo', 'swapVideosInList', 'updateVideo', 'setUserInfo', 'selectVideo', 'setSharedVideoCount', 'setActivePoint', 'setUserBalance', 'setLanguageSearchLabel', 'setCategorySearchLabel', 'addActivePoint']),
        navbarSelectNewVideoCategory(category, subcategory, idx) {
            if (this.parentName === 'detail') {
                let query = { path: '/',
                    query: {
                        category: category,
                        subcategory: subcategory
                    }}
                let route = this.$router.resolve(query)
                window.open(route.href, '_blank')
            } else {
                this.$parent.selectNewVideoCategory(category, subcategory, idx)
            }
            this.isShowDrawer = false
        },
        jumpSign() {
            this.$router.push(this.userInfo ? '/mine?feature=sign&from=home' : '/login?login=1')
        },
        mobileSelectLanguageVideo(type, language) {
            this.$parent.selectLanguageVideo(type, language)
            this.isShowDrawer = false
        },
        mobileNavbarSelect(e) {
            this.navbarSelectNewVideoCategory(e, 'all', 0)
            this.setMobileSubcategory(e)
        },
        closeTips() {
            this.isShowTips = false
            window.localStorage.setItem('isShowNavBarTips', false)
        },
        setMobileSubcategory(sub) {
            switch (sub) {
            case 'tvseries':this.mobileSubcategory = this.$t('shareSubCategoryTVseries'); break
            case 'movies':this.mobileSubcategory = this.$t('shareSubCategoryMovie'); break
            case 'entertainment':this.mobileSubcategory = this.$t('shareSubCategoryEntertainment'); break
            case 'other':this.mobileSubcategory = this.$t('shareSubCategoryOther'); break
            default:break
            }
        },
        getDailyReward() {
            if (this.userInfo) {
                this.$bvModal.show('dailyRewardModal')
            } else {
                this.login()
            }
        },
        logoOpt() {
            if (this.$route.path === '/') {
                this.$router.go(0)
            } else {
                this.$router.push('/')
            }
        },
        searchVideos() {
            if (this.parentName === 'detail') {
                let query = { path: '/',
                    query: {
                        searchKeyWords: this.searchKeyWords
                    }}
                let route = this.$router.resolve(query)
                window.open(route.href, '_blank')
            } else {
                this.$parent.chageSearchKeyWords(this.searchKeyWords)
            }
        },
        selectLanguage(e) {
            this.optIdx = e
            this.$i18n.locale = e === 1 ? 'cn' : 'en'
        },
        setShowPanel(res, type) {
            if (!this.userInfo) {
                this.isShowLoginPanel = res
            } else {
                this.isShowSettingPanel = res
            }
        },
        login() {
            this.$bvModal.show('modal-login')
        },
        openShareModal() {
            if (this.userInfo) {
                if (!navigator.clipboard) {
                    this.setSharingVideoURL('')
                    return
                }
                navigator.clipboard.readText().then(videoURL => {
                    let videoId = parseYoutubeVideoID(videoURL)
                    let videoIdBilibili = parseBilibiliVideoID(videoURL)
                    let videoIdTencent = parseTencentVideoId(videoURL)
                    let videoIdSubo = parseSuboVideoId(videoURL)
                    if (videoId) {
                        this.loading = true
                        getVideo(videoId).then(res => {
                            this.setGivePetalVideo(res.data)
                        }).catch(() => {
                            this.setSharingVideoURL(videoURL)
                        }).finally(() => {
                            this.loading = false
                        })
                    } else if (videoIdBilibili) {
                        this.loading = true
                        getVideo(videoIdBilibili, 'bilibili').then(res => {
                            this.setGivePetalVideo(res.data)
                        }).catch(() => {
                            this.setSharingVideoURL(videoURL)
                        }).finally(() => {
                            this.loading = false
                        })
                    } else if (videoIdTencent) {
                        this.loading = true
                        getVideo(videoIdTencent, 'tencent').then(res => {
                            this.setGivePetalVideo(res.data)
                        }).catch(() => {
                            this.setSharingVideoURL(videoURL)
                        }).finally(() => {
                            this.loading = false
                        })
                    } else if (videoIdSubo) {
                        this.loading = true
                        getVideo(videoIdSubo, 'subo').then(res => {
                            this.setGivePetalVideo(res.data)
                        }).catch(() => {
                            this.setSharingVideoURL(videoURL)
                        }).finally(() => {
                            this.loading = false
                        })
                    } else {
                        this.setSharingVideoURL('')
                    }
                }).catch(() => {
                    this.setSharingVideoURL('')
                })
            } else {
                this.login()
            }
        }
    },
    components: {
        Loading,
        Profile
    }
}
</script>
<style lang="scss">
    .popover_label{
        .label_title{
            height: 38px;
            border-radius: 8px;
            line-height: 38px;
            padding-left: 5px;
            white-space: nowrap;
        }
        .label_title:hover{
            background: #f2f2f2;
        }
    }

    .category_tooltip{
        z-index: 99999 !important;
    }

    .category_drawer{
        box-shadow: 0 10px 20px 0 RGBA(0, 0, 0, 0.1);
        margin-top: 7.5rem;

       .mobile_filter_container{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;

            .filter_title{
                // color: #666666;
                font-size: 16px;
                font-weight: bold;
                margin-left: 20px;
            }

            .filter_des{
                display: flex;
                align-items:center;
                justify-content:space-between;
                flex-wrap:wrap;
            }

            .subcategory_mobile{
            width: 90%;
            margin-bottom: 30px;
            }

            .filter_btn_mobile{
                width: 120px;
                height: 36px;
                background-color: #E5E5E5;
                border-radius: 36px;
                color: #a0a0a0;
                text-align: center;
                line-height: 36px;
                font-size: 15px;
                position: absolute;
                bottom: 10px;
            }
        }
     }
</style>
<style lang='scss' scoped>
    @media screen and (max-width: 768px) {
    .navbar{
        height: 7.5rem !important;
        z-index: 9999 !important;
    }
      }
.navbar{
    width: 100%;
    height: 6.5rem;
    position: fixed;
    top: 0;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    transition-property: background-color;
	transition-duration: 0.3s;
	transition-timing-function: ease-in-out;

    .nav_container_header_mobile{
        display: none;
    }

    .nav_container_category_mobile{
        display: none;
    }

    .nav_container{
      width: 80%;
      display: flex;
      align-items: center;
      justify-content: space-between;

    .logo{

        .logo_img{
            width: 170px;
            cursor: pointer;
        }

        .logo_short_img{
            width: 52px;
            cursor: pointer;
        }
    }

    .category_container{
        display: flex;
        align-items: center;
        justify-content: space-between;

        .video_type_btn{
            height: 40px;
            width: 126px;
            border-radius:22px;
            display: flex;
            align-items: center;
            // justify-content: space-around;
            margin-left: 10px;

            .tv_series{
                width: 20px;
                height: 17.5px;
                margin-left: 10px;
            }

            .category_name{
                color: #bcbcbc;
                font-size: 16px;
                font-weight: bold;
                white-space: nowrap;
                margin-left: 10px;
            }
        }

        .video_type_btn_active{
            background-color: #F06565;

            .el-icon-arrow-down{
                color: #FFFFFF;
            }

            .category_name{
                color: #FFFFFF;
            }
        }
        }

    .ipt{
        width: 30%;
        margin-left: 10%;
        .search_ipt{
            border: 1px solid RGB(240, 101, 101);
            border-radius: 26.5px;
            background-color: #fff;
        }
        >>>.el-input__inner{
            width: 95%;
            border: none;
            border-radius: 26.5px;
            color: RGB(0, 0, 0) !important;
            margin-left: 5%;
            font-size: 15px;
            background-color: #fff;

            &::placeholder {
                color: #d3d3d3;
                font-size: 15px;
            }
        }
        >>>.el-input-group__append{
            background-color: #F06565;
            color: #ffffff;
            border: 1px solid RGB(240, 101, 101);
            border-top-right-radius: 26.5px;
            border-bottom-right-radius: 26.5px;
            cursor: pointer;
            font-weight: bold;
        }
    }

    .ipt_change{
        .search_ipt{
            border-radius: 26.5px;
            background-color: #fff;
        }
        >>>.el-input__inner{
            width: 95%;
            border: none;
            border-radius: 26.5px;
            color: RGB(0, 0, 0) !important;
            margin-left: 5%;
            font-size: 15px;
            background-color: #fff;

            &::placeholder {
                color: #d3d3d3;
                font-size: 15px;
            }
        }
        >>>.el-input-group__append{
            color: #F06565;
            border: none;
            background-color: #fff;
            border-top-right-radius: 26.5px;
            border-bottom-right-radius: 26.5px;
            cursor: pointer;
            font-weight: bold;
        }
    }

    .opt_btn{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .opt_common{
            width: 80px;
            height: 80px;
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            margin-left: 10px;
            cursor: pointer;
            margin-top: 5px;
            padding: 5px;
        }

        .opt_common:hover{
            background-color: var(--bgc-color);
        }

        .opt_text{
            color: #666666;
            font-size: 13px;
            white-space: nowrap;
        }

        .opt_share{

            img{
                width: 46px;
                height: 30px;
            }
        }

        .opt_sign{
            img{
                width: 35px;
                height: 36px;
            }
        }

        .opt_mine{
            img{
                width: 42px;
                height: 41px;
            }
        }

        .opt_language{
            justify-content: center;
            padding: 0px;

            img{
                width: 30px;
                height: 25px;
            }

            >>>.el-input__inner{
                background-color: transparent;
                color:#fff;
                border:none;
                border-radius:0px;
            }

            >>>.el-input__prefix {
            display: flex;
            align-items: center;
            margin-left: 15px;
            }

            >>>.el-select .el-input .el-select__caret {
                color: #646464;
                font-weight: bold;
            }
            >>>.el-popper .popper__arrow, .el-popper .popper__arrow::after{
                display: none;
            }
        }
    }

    .login_panel{
        position: absolute;
        top: 6rem;
        right: 15%;
        width: 334px;
        height: 282px;
        background-color: #ffffff;
        border-radius: 8px;
        box-shadow:  0 10px 20px 0 RGBA(0, 0, 0, 0.3);
        // border: 1px solid rgba(151,151,151,1);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;

        .login_panel_title{
            width: 93%;
            text-align: left;
            font-size: 16px;
            color: rgba(0,0,0,0.5)
        }

        .login_panel_features{
            width: 90%;
            display: flex;
            align-items: center;
            justify-content: space-around;

            .features{
                height: 140px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-around;
                .features_sign{
                    width: 80px;
                    height: 91px;
                }
                .features_share{
                    width: 86px;
                    height: 91px;
                }
                .features_comment{
                    width: 83px;
                    height: 91px;
                }
                span{
                    font-size: 14px;
                    color: rgba(0,0,0,0.5);
                }
            }

        }

        .login_panel_btn{
            width: 60%;
            height: 44px;
            background-color: #f06565;
            border-radius: 22px;
            text-align: center;
            line-height: 44px;
            font-weight: bold;
            font-size: 18px;
            color: #fff;
            cursor: pointer;
        }
    }

     .setting_panel{
        height: 350px;
    }

    .login_panel_change{
        background-color: #212121;

        .login_panel_title{
            color: #ffffff
        }

        .login_panel_features{
            .features{
                span{
                color: #ffffff
                }
            }
        }
    }
    }
    @media screen and (max-width: 768px) {
    .navbar{
        height: 7rem;
        border:1px solid red
    }

        .nav_container{
            display: none;
        }

        .nav_container_header_mobile{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .mobile_sign{
                img{
                width: 40px;
                height: 40px;
                }
            }

            .mobile_search{
                    // width: 30%;
                .search_ipt{
                    border-radius: 40px;
                }
                >>>.el-input__inner{
                    width: 100%;
                    border: none;
                    border-radius: 40px;
                    color: #000 !important;
                    font-size: 15px;
                    background-color: #f5f5f5;

                    &::placeholder {
                        color: #ababab;
                        font-size: 15px;
                    }
                }
            }

            .mobile_category{

                .mobile_category_btn{
                    width: 65px;
                    height: 36px;
                    border-radius: 36px;
                    text-align: center;
                    line-height: 36px;
                    box-shadow:  0 5px 15px 0 RGBA(0, 0, 0, 0.15);
                    font-size: 14px;
                    font-weight: bold;
                }

            }
        }

        .nav_container_category_mobile{
             width: 100%;
             height: 50px;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue